import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/Tabs/Tabs";
import { Separator } from "../../../ui/Separator";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { useFetch } from "../../../hooks/useFetch";
import { EquipmentType } from "../../../types/types";
import TypesMainTab from "./typesItemTabs/TypesMainTab";
import TypesSettingsTab from "./typesItemTabs/TypesSettingsTab";
import Spinner from "../../../ui/Spinner/Spinner";
import { ScrollArea } from "../../../ui/ScrollArea/ScrollArea";
import { TbArrowLeft } from "react-icons/tb";

const EquipmentTypeItem = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/directories/equipment_types/${id}`);

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    doFetchItem();
  }, [id]);

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) return;
    setCurrentEquipmentType(response.data as unknown as EquipmentType);
    setLoading(false);
  }, [response]);

  const [currentEquipmentType, setCurrentEquipmentType] = useState<EquipmentType>();

  return loading ? (
    <Spinner />
  ) : (
    <ScrollArea className="w-full">
      <div className="flex flex-col w-full h-full max-w-[800px] ">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <NavLink to={"/data/equipment_types"} className="text-sm flex gap-2 items-center text-muted-foreground"><TbArrowLeft />{t("equipment_types")}</NavLink>
            <span className="text-2xl font-semibold">{t('editing_equipment_type')}</span>
          </div>
        </div>
        <Tabs defaultValue="settings" >
          <div className="px-6">
            <TabsList className="w-full flex-none h-10 justify-between px-2 rounded">
              <div className="flex">
                <TabsTrigger value="settings">{t("settings")}</TabsTrigger>
              </div>
            </TabsList>
          </div>
          <TabsContent value="settings">
            <TypesSettingsTab id={id} currentEquipmentType={currentEquipmentType} />
          </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
};

export default EquipmentTypeItem;
